/**
 * Find and return the viewport element for a page.
 *
 * Should not really return the page viewport for a dialog, but probably the document body. Works for now though.
 * Slightly awkward because it's a core component that references worksheets, but it keeps things simple.
 *
 * @returns The viewport, a DOM element
 */
export const useViewport = () =>
  document.getElementsByClassName('WorksheetPage-Content')[0] ??
  document.getElementsByClassName('Page-Viewport')[0] ??
  document.body;
